import { Box, Typography } from "components"
import { BasePreviewProps } from "."

export const CheckboxPreviewComponent = (props: BasePreviewProps) => {
  const { label, value } = props
  const displayValue = value ? "ใช่" : "ไม่ใช่"
  return (
    <>
      <Typography variant="body1" color="Text/Gray Preview">
        {label}
      </Typography>
      <Box mt="4px">
        <Typography variant="h4" color="Text/Black2">
          {displayValue}
        </Typography>
      </Box>
    </>
  )
}
